import React from 'react'
import { Link } from 'react-router-dom';
import classes from './Tabs.module.css';

function Tabs(props) {
  return (
    <div className={classes.sec_tabs}>
        <ul className="nav nav-tabs-line">
            <li className={`${classes.tab} ${props.active === 'soundcloud' && classes.active}`}><Link to="/share/soundcloud"><i className="fa-brands fa-soundcloud"></i>SoundCloud</Link></li>
            <li className={`${classes.tab} ${props.active === 'music' && classes.active}`}><Link to="/add-music"><i className="fa-solid fa-file-audio"></i>Music mp3</Link></li>
        </ul>
    </div>
  )
}

export default Tabs